<div class="p-4 max-w-7xl mx-auto">
  <!-- Title / Header -->
  <div class="mb-6 flex flex-col md:flex-row md:items-center md:justify-between border-b pb-4">
    <div>
      <h1 class="text-2xl font-bold text-0d5bab">Direct Cash / Metal Entry</h1>
      <p class="text-sm text-gray-500">Record cash or metal received other than sales to update in-hand balances.</p>
    </div>
    <div class="mt-2 md:mt-0 bg-fff9f9 border border-c19725 px-4 py-2 rounded-md">
      <span class="text-sm font-semibold text-black">Active Firm:</span>
      <span class="text-sm font-bold text-c19725 ml-1">{{ currentFirmName || 'None' }}</span>
    </div>
  </div>

  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
    <!-- Left column: The form -->
    <div class="lg:col-span-1">
      <div class="bg-white border border-d9d9d9 rounded-lg shadow-sm overflow-hidden">
        <div class="bg-fff9f9 p-3 border-b border-d9d9d9">
          <h2 class="text-lg font-semibold text-black text-center capitalize">New Entry Form</h2>
        </div>

        <form (ngSubmit)="onSubmit()" #entryForm="ngForm" class="p-4 space-y-4">
          <!-- Entry Date -->
          <div class="relative">
            <input type="date" id="entryDate" name="entryDate" placeholder=" "
              [(ngModel)]="entryDate" required
              class="block px-3 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
            <label for="entryDate"
              class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-2">
              Entry Date
            </label>
          </div>

          <!-- Entry Type Segmented Control -->
          <div>
            <label class="block text-[13px] font-medium text-gray-600 mb-1.5">Entry Type</label>
            <div class="grid grid-cols-2 gap-2">
              <button type="button" (click)="entryType = 'cash'"
                [ngClass]="entryType === 'cash' ? 'bg-metal-settled-blue text-white border-metal-settled-blue' : 'bg-white text-gray-700 border-gray-300'"
                class="py-2 text-sm font-medium border rounded-md transition-all duration-200">
                Cash
              </button>
              <button type="button" (click)="entryType = 'metal'"
                [ngClass]="entryType === 'metal' ? 'bg-metal-settled-blue text-white border-metal-settled-blue' : 'bg-white text-gray-700 border-gray-300'"
                class="py-2 text-sm font-medium border rounded-md transition-all duration-200">
                Metal
              </button>
            </div>
          </div>

          <!-- Person Name -->
          <div class="relative">
            <input type="text" id="personName" name="personName" placeholder=" "
              [(ngModel)]="personName" required
              class="block px-3 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
            <label for="personName"
              class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-2">
              Person Name
            </label>
          </div>

          <!-- Source -->
          <div class="relative">
            <input type="text" id="source" name="source" placeholder=" "
              [(ngModel)]="source"
              class="block px-3 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
            <label for="source"
              class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-2">
              Source / Description
            </label>
          </div>

          <!-- Conditional Fields based on Cash vs Metal -->
          <div *ngIf="entryType === 'cash'" class="space-y-4">
            <!-- Amount -->
            <div class="relative">
              <input type="number" id="amount" name="amount" placeholder=" "
                [(ngModel)]="amount" required min="1"
                class="block px-3 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
              <label for="amount"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-2">
                Cash Amount (₹)
              </label>
            </div>
          </div>

          <div *ngIf="entryType === 'metal'" class="space-y-4">
            <!-- Gross Weight -->
            <div class="relative">
              <input type="number" id="grossWeight" name="grossWeight" placeholder=" "
                [(ngModel)]="grossWeight" (input)="calculateNetWeight()" required min="0.001" step="0.001"
                class="block px-3 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
              <label for="grossWeight"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-2">
                Gross Weight (gm)
              </label>
            </div>

            <!-- Purity / Tunch -->
            <div class="relative">
              <input type="number" id="purity" name="purity" placeholder=" "
                [(ngModel)]="purity" (input)="calculateNetWeight()" required min="0" max="100" step="0.01"
                class="block px-3 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
              <label for="purity"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-2">
                Purity / Tunch (%)
              </label>
            </div>

            <!-- Net Weight -->
            <div class="relative">
              <input type="number" id="netWeight" name="netWeight" placeholder=" "
                [(ngModel)]="netWeight" required min="0.001" step="0.001"
                class="block px-3 py-2 w-full text-[13px] text-383838 font-normal bg-gray-50 rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer" />
              <label for="netWeight"
                class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-2">
                Net Weight (gm)
              </label>
            </div>
          </div>

          <!-- Submit Buttons -->
          <div class="pt-2 flex gap-3">
            <button type="submit" [disabled]="isSubmitting || !entryForm.form.valid"
              class="w-full py-2 bg-018f37 text-white text-sm font-medium rounded-md hover:bg-green-700 hover:shadow transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
              {{ isSubmitting ? 'Recording...' : (isEditing ? 'Update Entry' : 'Submit Entry') }}
            </button>
            <button type="button" (click)="resetForm()"
              class="px-4 py-2 border border-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-50 transition-all duration-200">
              {{ isEditing ? 'Cancel' : 'Reset' }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Right column: The list of entries -->
    <div class="lg:col-span-2">
      <div class="bg-white border border-d9d9d9 rounded-lg shadow-sm overflow-hidden">
        <div class="bg-fff9f9 p-3 border-b border-d9d9d9 flex justify-between items-center">
          <h2 class="text-lg font-semibold text-black capitalize">Entry History</h2>
          <div class="flex items-center gap-3">
            <div class="flex items-center gap-1.5">
              <label class="text-xs text-gray-500 font-medium whitespace-nowrap">Rows per page:</label>
              <select [(ngModel)]="itemsPerPage" (ngModelChange)="onItemsPerPageChange()"
                class="text-xs border border-d9d9d9 rounded px-2 py-1 text-gray-700 focus:outline-none focus:border-c19725">
                <option [value]="5">5</option>
                <option [value]="10">10</option>
                <option [value]="25">25</option>
                <option [value]="50">50</option>
                <option [value]="100">100</option>
              </select>
            </div>
            <button (click)="fetchEntries()" class="text-sm font-semibold text-0d5bab hover:underline flex items-center gap-1">
              <svg class="size-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 1121.21 7.89M9 11l3-3 3 3m-3-3v12" />
              </svg>
              Refresh
            </button>
          </div>
        </div>

        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Date</th>
                <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Person Name</th>
                <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Type</th>
                <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Details</th>
                <th class="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Source</th>
                <th class="px-4 py-3 text-center text-xs font-semibold text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr *ngFor="let entry of paginatedEntries" class="hover:bg-gray-50 transition-colors duration-150">
                <td class="px-4 py-3.5 whitespace-nowrap text-sm text-gray-700">
                  {{ entry.entry_date | date: 'dd/MM/yyyy' }}
                </td>
                <td class="px-4 py-3.5 whitespace-nowrap text-sm font-semibold text-black">
                  {{ entry.person_name }}
                </td>
                <td class="px-4 py-3.5 whitespace-nowrap text-sm">
                  <span [ngClass]="entry.entry_type === 'cash' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'"
                    class="px-2.5 py-1 text-xs font-medium rounded-full uppercase">
                    {{ entry.entry_type }}
                  </span>
                </td>
                <td class="px-4 py-3.5 text-sm text-gray-800">
                  <div *ngIf="entry.entry_type === 'cash'" class="font-semibold text-green-700">
                    ₹ {{ entry.amount | number: '1.2-2' }}
                  </div>
                  <div *ngIf="entry.entry_type === 'metal'">
                    <span class="font-semibold">{{ entry.net_weight | number: '1.3-3' }} gm</span> Net
                    <span class="text-xs text-gray-500 block">Gross: {{ entry.gross_weight }} gm ({{ entry.purity }}%)</span>
                  </div>
                </td>
                <td class="px-4 py-3.5 text-sm text-gray-600">
                  {{ entry.source || '-' }}
                </td>
                <td class="px-4 py-3.5 whitespace-nowrap text-center text-sm font-medium">
                  <div class="flex items-center justify-center gap-3">
                    <!-- Print Button -->
                    <button (click)="printReceipt(entry)" title="Print Receipt"
                      class="p-1 text-0d5bab hover:text-blue-800 rounded hover:bg-blue-50 transition-colors">
                      <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                      </svg>
                    </button>
                    <!-- Edit Button -->
                    <button (click)="editEntry(entry)" title="Edit Entry"
                      class="p-1 text-c19725 hover:text-amber-700 rounded hover:bg-amber-50 transition-colors">
                      <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <!-- Delete Button -->
                    <button (click)="deleteEntry(entry.id)" title="Delete Entry"
                      class="p-1 text-red-600 hover:text-red-800 rounded hover:bg-red-50 transition-colors">
                      <svg class="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              <tr *ngIf="paginatedEntries.length === 0">
                <td colspan="6" class="px-4 py-8 text-center text-sm text-gray-500">
                  <div *ngIf="isLoading" class="flex justify-center items-center gap-2">
                    <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-0d5bab"></div>
                    Loading entries...
                  </div>
                  <div *ngIf="!isLoading">
                    No direct cash or metal entries found for this firm.
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination Controls -->
        <div *ngIf="totalPages > 1" class="flex items-center justify-between px-4 py-3 border-t border-d9d9d9 bg-fff9f9">
          <p class="text-xs text-gray-500">
            Showing {{ (p - 1) * itemsPerPage + 1 }}–{{ p * itemsPerPage > entries.length ? entries.length : p * itemsPerPage }} of {{ entries.length }} entries
          </p>
          <div class="flex items-center gap-1">
            <button (click)="goToPreviousPage()" [disabled]="p === 1"
              class="px-2.5 py-1.5 text-xs font-medium rounded border border-d9d9d9 text-gray-600 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
              ‹ Prev
            </button>
            <ng-container *ngFor="let page of pageNumbers">
              <button *ngIf="page !== '...'" (click)="onPageChange(+page)"
                [ngClass]="p === +page ? 'bg-metal-settled-blue text-white border-metal-settled-blue' : 'bg-white text-gray-700 border-d9d9d9 hover:bg-gray-100'"
                class="px-2.5 py-1.5 text-xs font-medium rounded border transition-colors">
                {{ page }}
              </button>
              <span *ngIf="page === '...'" class="px-1.5 py-1.5 text-xs text-gray-500">…</span>
            </ng-container>
            <button (click)="goToNextPage()" [disabled]="p === totalPages"
              class="px-2.5 py-1.5 text-xs font-medium rounded border border-d9d9d9 text-gray-600 hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
              Next ›
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
